export default function inView(node, params) {
    let observer;
    const handleIntersect = entries => {
        entries.forEach(entry => {
            node.dispatchEvent(new CustomEvent("intersect", {
                detail: entry.isIntersecting,
            }));
            if (entry.isIntersecting && params.unobserveOnEnter) {
                observer.unobserve(node);
            }
        });
    };
    const setObserver = (options) => {
        const defaultOptions = {
            root: null,
            rootMargin: "0px",
            threshold: 0,
        };
        if (observer)
            observer.disconnect();
        observer = new IntersectionObserver(handleIntersect, options ? options : defaultOptions);
        observer.observe(node);
    };
    setObserver(params);
    return {
        update(params) {
            setObserver(params);
        },
        destroy() {
            if (observer)
                observer.disconnect();
        },
    };
}
